const addressFieldsModel = [
    'Composite',
    'LevelTypeCode',
    'LevelNumberSuffix',
    'LevelNumber',
    'Postcode',
    'Suburb',
    'StateName',
    'StreetType',
    'StreetName',
    'StreetSuffixCode',
    'StreetNumber2',
    'StreetNumber1Suffix',
    'StreetNumber',
    'UnitTypeCode',
    'UnitSuffix',
    'UnitNumber',
];
export default addressFieldsModel;
